<template>
  <main>
    <OrganismInitialAccess/>
  </main>
</template>

<script>
export default {
  name: 'InitialAccess',

  components: {
    OrganismInitialAccess: () => import('@/components/organisms/OrganismInitialAccess')
  }
}
</script>
